module.exports = __webpack_public_path__ + "static/smardtv-3067e166febd2986d6f8e4951af0e3bc.png";